<template>
  <div class="content">
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <a data-toggle="collapse" href="#filter" role="button" aria-expanded="false" aria-controls="filter">
            {{ $t('app.filter') }}
          </a>
          |
          <a data-toggle="collapse" href="#searchdebtor" role="button" aria-expanded="false" aria-controls="searchdebtor">
            {{ $t('app.find_debtor') }}
          </a>
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="datatable_filter float-right">
            <div class="row">
              <div class="col">
                <div class="form-check" v-if="permissions.indexOf('archive-debts') != -1">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="showNextContactToday"
                    v-model="filter.archive"
                    @change="fetchDebts"
                    true-value="1"
                    false-value="0"
                  >
                  <label class="form-check-label" for="showNextContactToday">{{ $t('app.show_archive') }}</label>
                </div>
              </div>
              <div class="col">
                <label>
                  <select v-model="tableData.length" @change="fetchDebts()" class="form-control form-control-sm">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="collapse" id="filter">
        <div class="card card-body mb-3">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label for="midlename" class="col-form-label">{{ $t('debts.status.name') }}</label>
                  <select class="form-control form-control-sm" v-model="filter.status_id">
                    <option selected="true" value="">{{ $t('field.any') }}</option>
                    <option v-for="status in adminListDebtStatuses" :value="status.id" :key="status.id">
                      {{ status.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="datenextcontact" class="col-form-label">{{ $t('debts.next_contact') }}</label>
                  <input type="date" class="form-control form-control-sm" id="datenextcontact" v-model="filter.next_contact">
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="col-form-label">{{ $t('users.user') }}</label>
                  <select class="form-control form-control-sm" v-model="filter.user_id">
                    <option selected="true" value="">{{ $t('field.any') }}</option>
                    <option v-for="user in adminListUsers" :value="user.id" :key="user.id">
                      {{ user.fullname }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="col-form-label">{{ $t('debts.contragent') }}</label>
                  <select class="form-control form-control-sm" v-model="filter.contragent_id">
                    <option selected="true" value="">{{ $t('field.any') }}</option>
                    <option v-for="contragent in adminListContragents" :value="contragent.id" :key="contragent.id">
                      {{ contragent.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="col-form-label">{{ $t('debts.registry_date') }}</label>
                  <select class="form-control form-control-sm" v-model="filter.registry_date">
                    <option selected="true" value="">{{ $t('field.any') }}</option>
                    <option v-for="date in adminListRegistryDates" :value="date.registry_date" :key="date.registry_date">
                      {{ date.registry_date }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="col-form-label">{{ $t('debts.created_at') }}</label>
                  <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="datestart">C</span>
                    </div>
                    <input type="date" class="form-control" aria-label="Small" v-model="filter.period_imported_start_date" aria-describedby="datestart" />
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="col-form-label">{{ $t('debts.created_at') }}</label>
                  <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="dateend">По</span>
                    </div>
                    <input type="date" class="form-control" aria-label="Small" v-model="filter.period_imported_end_date" aria-describedby="dateend" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="text-center">
                  <div class="btn-group" role="group" aria-label="btnGroup1">
                    <button class="btn btn-primary" @click="findDebt()">
                      <font-awesome-icon icon="search" /> {{ $t('field.find') }}
                    </button>
                    <button class="btn btn-danger" @click="resetForm()">
                      <font-awesome-icon icon="times" /> {{ $t('field.reset') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>

      <div class="collapse" id="searchdebtor">
        <div class="card card-body mb-3">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label for="midlename" class="col-form-label">{{ $t('debtors.lastname') }}</label>
                  <input type="text" class="form-control form-control-sm" :placeholder="$t('placeholder.enter_debtor_lastname')" id="midlename" v-model="filter.lastname">
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="name" class="col-form-label">{{ $t('debtors.firstname') }}</label>
                  <input type="text" class="form-control form-control-sm" :placeholder="$t('placeholder.enter_debtor_firstname')" id="name" v-model="filter.firstname">
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="lastname" class="col-form-label">{{ $t('debtors.middlename') }}</label>
                  <input type="text" class="form-control form-control-sm" :placeholder="$t('placeholder.enter_debtor_middlename')" id="lastname" v-model="filter.middlename">
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="birth_day" class="col-form-label">{{ $t('debtors.birth_day') }}</label>
                  <input type="date" class="form-control form-control-sm" id="birth_day" v-model="filter.birth_day">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="iin" class="col-form-label">{{ $t('debtors.iin') }}</label>
                  <input type="text" class="form-control form-control-sm" :placeholder="$t('placeholder.enter_debtor_iin')" id="iin" v-model="filter.iin">
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="debt_number" class="col-form-label">{{ $t('debts.number') }}</label>
                  <input type="text" class="form-control form-control-sm" :placeholder="$t('placeholder.enter_debt_number')" id="debt_number" v-model="filter.debt_number">
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="phone" class="col-form-label">{{ $t('phones.phone') }}</label>
                  <input type="text" class="form-control form-control-sm" :placeholder="$t('placeholder.enter_debtor_phone')" id="phone" v-model="filter.phone">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="text-center">
                  <div class="btn-group" role="group" aria-label="btnGroup1">
                    <button class="btn btn-primary" @click="findDebt()">
                      <font-awesome-icon icon="search" /> {{ $t('field.find') }}
                    </button>
                    <button class="btn btn-danger" @click="resetForm()">
                      <font-awesome-icon icon="times" /> {{ $t('field.reset') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>

      <div class="block block-rounded block-fx-shadow">
        <div class="block-header">
          <h3 class="block-title">{{ $t('debts.index') }} {{pagination.total ? '(' + pagination.total + ')': '' }}</h3>
        </div>
        <div class="table-responsive">
          <datatable class="m-0" :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" :loading="loadDebts" @sort="sortBy" >
            <tbody>
              <tr
                v-for="(debt, index) in debts"
                :key="debt.id"
                :class="{'table-danger': debt.next_contact < today,'table-warning': debt.next_contact == today,'table-success': debt.next_contact > today,}"
              >
                <td>{{index+1}}</td>
                <td>
                  <div class="btn-group" v-if="debt.deleted_at == null">
                    <a
                      :href="`/debt/${debt.id}`"
                      class="btn btn-sm btn-success"
                      target="_blank"
                      title="Открыть"
                    >
                      <i class="fa fa-eye"></i>
                    </a>
                    <a
                      :href="`/admin/debts/${debt.id}/edit`"
                      class="btn btn-sm btn-primary"
                      target="_blank"
                      title="Редактировать"
                      v-if="permissions.indexOf('update-debts') != -1"
                    >
                      <i class="fa fa-edit"></i>
                    </a>
                    <button
                      @click.prevent="handleDelete(debt.id)"
                      class="btn btn-danger btn-sm "
                      :disabled="isProcessing"
                      title="Удалить"
                      v-if="permissions.indexOf('delete-debts') != -1"
                    >
                      <i class="fa fa-times-circle"></i>
                    </button>
                  </div>
                  <div class="btn-group" v-if="debt.deleted_at">
                    <a
                      :href="`/debt/${debt.id}`"
                      class="btn btn-sm btn-info"
                      target="_blank"
                      title="Открыть"
                    >
                      <i class="fa fa-eye"></i>
                    </a>
                    <button @click.prevent="handleRestore(debt.id)" class="btn btn-success btn-sm " :disabled="isProcessing" >
                      {{ $t('buttons.restore') }}
                    </button>
                  </div>

                </td>
                <td>{{debt.number}}</td>
                <td>{{debt.debtor ? debt.debtor.fullname: '' }}</td>
                <td>{{debt.debtor ? debt.debtor.iin : '' }}</td>
                <td>{{debt.status ? debt.status.name : '' }}</td>
                <td>{{debt.user ? debt.user.fullname : 'не назначен исполнитель' }}</td>
                <td>{{debt.current_arrears}} <span v-if="debt.current_arrears">тг</span></td>
                <td>{{debt.loading_current_arrears}} <span v-if="debt.loading_current_arrears">тг</span></td>
                <td>
                  {{debt.last_contact | datetimeFormat}}
                </td>
                <td>
                  {{debt.next_contact | dateFormat}}<br>
                  <span v-if="debt.next_contact == today" class="badge badge-pill badge-danger">{{ $t('app.today') }}</span>
                  <span v-if="debt.next_contact == tomorrow" class="badge badge-pill badge-warning">{{ $t('app.tomorrow') }}</span>
                </td>
                <td>{{debt.start_date | dateFormat}}</td>
                <td>{{debt.delay_credit_day}}</td>
                <td>{{debt.created_at | datetimeFormat}}</td>
              </tr>
              <tr v-if="debts.length == 0 && !loadDebts">
                <td :colspan="columns.length" class="text-center">{{ $t('app.empty') }}</td>
              </tr>
            </tbody>
          </datatable>
        </div>
      </div>
      <pagination :pagination="pagination" :offset="4" @paginate="fetchDebts()"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';

export default {
  data() {
    return {
      debts: [],
      today: moment().format('YYYY-MM-DD'),
      tomorrow: moment().add(1, 'days').format('YYYY-MM-DD'),
      columns: [
        { label: '#', name: 'index', disableOrder: true },
        { label: '', name: 'action', disableOrder: true },
        { label: this.$t('debts.number_short'), name: 'debts.number' },
        { label: this.$t('debtors.fullname'), name: 'debtors.fullname' },
        { label: this.$t('debtors.iin'), name: 'debtors.iin' },
        { label: this.$t('field.status'), name: 'debt_statuses.name' },
        { label: this.$t('users.user'), name: 'users.firstname' },
        { label: this.$t('debts.current_arrears'), name: 'debts.current_arrears' },
        { label: this.$t('debts.loading_current_arrears'), name: 'debts.loading_current_arrears' },
        { label: this.$t('debts.last_contact_short'), name: 'debts.last_contact' },
        { label: this.$t('debts.next_contact_short'), name: 'debts.next_contact' },
        { label: this.$t('debts.start_date'), name: 'debts.start_date' },
        { label: this.$t('debts.delay_credit_day'), name: 'debts.delay_credit_day' },
        { label: this.$t('debts.created_at'), name: 'debts.created_at' },
      ],
      sortKey: 'name',
      sortOrders: {},
      tableData: {
        draw: 0,
        length: 10,
        search: '',
        column: 0,
        dir: 'asc',
      },
      filter: {
        lastname: this.$route.query.lastname,
        firstname: this.$route.query.firstname,
        middlename: this.$route.query.middlename,
        iin: this.$route.query.iin,
        debt_number: this.$route.query.debt_number,
        birth_day: this.$route.query.birth_day,
        phone: this.$route.query.phone,
        status_id: this.$route.query.status_id || '',
        next_contact: this.$route.query.next_contact,
        archive: 0,
        user_id: this.$route.query.user_id || '',
        contragent_id: this.$route.query.contragent_id || '',
        registry_date: this.$route.query.registry_date || '',
        period_imported_start_date: '',
        period_imported_end_date: '',
      },
      pagination: {
        current_page: 1,
      },
      loadDebts: false,
      isProcessing: false,
    };
  },
  computed: {
    ...mapGetters([
      'adminListUsers',
      'adminListContragents',
      'adminListDebtStatuses',
      'adminListRegistryDates',
      'permissions',
    ]),
  },
  created() {
    this.fetchDebts();
    this.GET_ADMIN_LIST_DEBT_STATUSES();
    this.GET_ADMIN_LIST_CONTRAGENTS();
    this.GET_ADMIN_LIST_REGISTRY_DATES();
    this.GET_ADMIN_LIST_USERS();
    this.columns.forEach((column) => {
      this.sortOrders[column.name] = -1;
    });
  },
  methods: {
    ...mapActions([
      'GET_ADMIN_LIST_USERS',
      'GET_ADMIN_LIST_CONTRAGENTS',
      'GET_ADMIN_LIST_DEBT_STATUSES',
      'DELETE_ADMIN_DEBT',
      'RESTORE_ADMIN_DEBT',
      'GET_ADMIN_LIST_REGISTRY_DATES',
    ]),
    findDebt() {
      this.pagination.current_page = 1;
      this.fetchDebts();
    },

    fetchDebts() {
      this.loadDebts = true;
      this.tableData.draw += 1;

      const requests = { ...this.tableData, ...this.filter };
      window.axios.get(`/admin/debts?page=${this.pagination.current_page}`, { params: requests })
        .then((res) => {
          if (this.tableData.draw === res.data.draw) {
            this.debts = res.data.debts.data;
            this.pagination = this.laraPaginate(res.data.debts);
          } else {
            console.log('failed');
          }
          this.loadDebts = false;
        });
    },

    resetForm() {
      this.filter.lastname = '';
      this.filter.firstname = '';
      this.filter.middlename = '';
      this.filter.iin = '';
      this.filter.debt_number = '';
      this.filter.birth_day = '';
      this.filter.phone = '';
      this.filter.status_id = '';
      this.filter.next_contact = '';
      this.filter.user_id = '';
      this.filter.contragent_id = '';
      this.pagination.current_page = 1;
      this.fetchDebts();
    },

    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.column = this.getIndex(this.columns, 'name', key);
      this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
      this.fetchDebts();
    },

    handleDelete(id) {
      window.Swal.fire({
        title: this.$t('alerts.are_you_sure'),
        text: this.$t('alerts.want_to_delete'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('alerts.delete_it'),
        cancelButtonText: this.$t('field.cancel'),
      }).then((result) => {
        if (result.value) {
          this.isProcessing = true;
          this.DELETE_ADMIN_DEBT(id)
            .then(() => {
              this.isProcessing = false;
              this.fetchDebts();
            });
        }
      });
    },

    handleRestore(id) {
      window.Swal.fire({
        title: this.$t('alerts.are_you_sure'),
        text: this.$t('alerts.want_to_restore'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#28a745',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('alerts.restore_it'),
        cancelButtonText: this.$t('field.cancel'),
      }).then((result) => {
        if (result.value) {
          this.isProcessing = true;
          this.RESTORE_ADMIN_DEBT(id)
            .then(() => {
              this.isProcessing = false;
              this.fetchDebts();
            });
        }
      });
    },
  },
};
</script>
